import { Navigate } from 'react-router-dom';

import Home from '@App/pages/Home/Home';
import NoMatch from '@App/pages/NoMatch/NoMatch';
import CaseStudy from '@App/pages/CaseStudy/CaseStudy';
import CaseStudySection from '@App/pages/CaseStudy/CaseStudySection';

const routes = [
  {
    name: 'Home',
    path: '/',
    element: <Home />,
  },
  {
    name: 'Case study',
    path: '/:caseStudyId',
    element: <CaseStudy />,
    children: [
      {
        index: true,
        element: <Navigate to="context" replace />,
      },
      {
        path: ':sectionId',
        element: <CaseStudySection />,
      },
    ],
  },
  {
    name: 'Page Not Found',
    path: '*',
    element: <NoMatch />,
  },
];

export default routes;
